import React from "react";
import { useMsal } from "@azure/msal-react";

export default function Layout({ children }) {
  const { accounts, instance } = useMsal();
  const user = accounts[0];

  return (
    <div style={{ fontFamily: "Segoe UI, sans-serif", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      {/* Header */}
      <div style={{
        backgroundColor: "#0078d4",
        color: "white",
        padding: "12px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <span style={{ fontWeight: 600, fontSize: 18 }}>Team Tools</span>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <span style={{ fontSize: 14 }}>{user?.name}</span>
          <button
            onClick={() => instance.logoutPopup()}
            style={{
              background: "transparent",
              border: "1px solid white",
              color: "white",
              padding: "4px 12px",
              borderRadius: 4,
              cursor: "pointer",
              fontSize: 13
            }}
          >
            Sign out
          </button>
        </div>
      </div>

      {/* Page content */}
      <div style={{ padding: 32 }}>
        {children}
      </div>
    </div>
  );
}